export default __webpack_public_path__ + "static/media/diagnose.8ae41a60.png";